import { useQuery } from "@tanstack/react-query";
import { partnerApiService } from "@/services/partner-api.service";

export const useClientUsers = (teamId: string | undefined) => {
	return useQuery({
		queryKey: ["partner", "clients", teamId, "users"],
		queryFn: () => partnerApiService.listTeamUsers(teamId as string),
		enabled: !!teamId,
	});
};
